// src/components/Apm/BankAccount/BankAccounts.js

import { useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { useMediaQuery, useTheme } from '@mui/material';

import { getItems } from '../../../redux/slices/bankAccountSlice';

import { columnsBankAccounts } from '../Tables/Columns/columnsBankAccounts';

import TableSimple from '../Tables/TableSimple';

const MOBILE_COLUMN_IDS = new Set(['currency_code.currency_code', 'iban_number']);

const BankAccounts = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const theme = useTheme();

  const smMediaDown = useMediaQuery(theme.breakpoints.down('sm'));

  const { bankAccounts = [], statusBankAccounts = null } = useSelector((state) => state.bankAccountSlice ?? {});

  useEffect(() => {
    if (statusBankAccounts === null) {
      dispatch(getItems());
    }
  }, [dispatch, statusBankAccounts]);

  const updatedColumns = useMemo(() => {
    const columns = columnsBankAccounts(t);

    if (!smMediaDown) {
      return columns;
    }

    return columns.filter((column) => MOBILE_COLUMN_IDS.has(column.id));
  }, [smMediaDown, t]);

  return (
    <TableSimple
      resource="bank-accounts"
      columns={updatedColumns}
      popupTitle={t('popup.title.bank_account_details')}
      addButtonText={t('button.add_bank_account')}
      data={bankAccounts}
    />
  );
};

export default BankAccounts;
